











import Component from 'vue-class-component'
import { ISidebarMenuItemProps } from './ISidebarMenuItem'

@Component
export default class SidebarMenuItem extends ISidebarMenuItemProps {
    private componentClass = "SidebarMenuItem"
}
